import React, {Component} from 'react'
import styled from '@emotion/styled'
import {cloudRefiner} from '../../../../defaults/cloudMaker'

import sv from '../../../../styles/styles'
import GridCloud from "./GridCloud";

// STYLE ##########################################################

const Chapter = styled(`div`)`
  ${sv.flexColumn};
  ${sv.box};
  transition: opacity .2s ease-out;
  flex: 1;
  padding-top: 15px;
  width: 100%;
  height: 100%;
  position: relative;
  visibility: ${props => props.isCurrent ? 'visible' : 'hidden'};
`;

const CloudContainer = styled(`div`)`
  flex: 1;
  height: 100%;
  padding-left: 23px;
  padding-right: 23px;
`;

// COMPONENT ##########################################################

class UnifiedChapter extends Component {
  state = {
    cloud: [],
  };

  componentDidMount() {
  	this.updateCloud();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const chapWidthChanged = prevProps.chapterWidth !== this.props.chapterWidth;
    if (chapWidthChanged) {
    	this.updateCloud();
    }
  };

	updateCloud() {
		if(this.props.chapterWidth > 0) {
			const newCloud = cloudRefiner(this.props.cloud, 15);
			this.setState({
				cloud: newCloud
			});
		}
	}

  render = () => {
    return (
      <Chapter
        className="chapter"
        isCurrent={this.props.isCurrentChapter}
      >
        <CloudContainer>
            <GridCloud
                cloud={this.state.cloud}
                nextElement={this.props.nextElement}
                playWord={this.props.playWord}
                showWordOnTimeline={this.props.showWordOnTimeline}
                hideWordOnTimeline={this.props.hideWordOnTimeline}
                chapterWidth={this.props.chapterWidth}
                chapterNumber={this.props.chapterNumber}
                getGistPlayerRect={this.props.getGistPlayerRect}
                onHintTextShown={this.props.onHintTextShown}
                setLockGist={this.props.setLockGist}
            />
        </CloudContainer>
      </Chapter>
    )
  };
}

export default UnifiedChapter
